import { IMAGE_BASE } from '../constants/site';

export const FEATURED_ITEMS = [
  {
    image: `${IMAGE_BASE}/img15.jpg`,
    label: 'Traffic signals',
    title: 'Improving and repainting the road',
    large: true,
  },
  {
    image: `${IMAGE_BASE}/img16.jpg`,
    label: 'Traffic signals',
    title: 'Traffic light repair and equipment installation along major routes',
  },
  {
    image: `${IMAGE_BASE}/img08.jpg`,
    label: 'Safety areas',
    title: 'Workplace safety line marking for safer operations',
  },
  {
    image: `${IMAGE_BASE}/img17.jpg`,
    label: 'Road repair paint',
    title: 'Modern equipment for professional road painting',
  },
];

export const LATEST_PROJECTS = [
  {
    image: `${IMAGE_BASE}/img44.jpg`,
    title: 'Featured highway improvement project',
    featured: true,
  },
  {
    image: `${IMAGE_BASE}/img42.jpg`,
    title: 'Road construction from Kao Liew village to Moon the Night',
  },
  {
    image: `${IMAGE_BASE}/img43.jpg`,
    title: 'Guardrail installation in Sekong Province',
  },
  {
    image: `${IMAGE_BASE}/img45.jpg`,
    title: 'Lao-Thai Friendship Bridge crossing improvement',
  },
  {
    image: `${IMAGE_BASE}/img46.jpg`,
    title: 'Four-point traffic light system deployment',
  },
];

export const SIGNAGE_FEATURE = {
  image: `${IMAGE_BASE}/img10.jpg`,
  label: 'Drive safely',
  title: 'Premium aluminum signage engineered for durability, visibility, and long-term performance.',
};

export const SIGNAGE_ITEMS = [
  {
    image: `${IMAGE_BASE}/img11.jpg`,
    label: 'Traffic control',
    title: 'High-visibility cones and diversion equipment for safe roadworks.',
  },
  {
    image: `${IMAGE_BASE}/img12.jpg`,
    label: 'Warning signs',
    title: 'Weather-resistant warning signs for clear driver communication.',
  },
  {
    image: `${IMAGE_BASE}/img13.jpg`,
    label: 'Regulatory signs',
    title: 'Stop and regulatory signage built for high-traffic durability.',
  },
  {
    image: `${IMAGE_BASE}/img14.jpg`,
    label: 'Site safety',
    title: 'Complete site safety solutions for highways and workplaces.',
  },
];

export const CLIENT_LOGOS = Array.from({ length: 21 }, (_, index) => {
  const number = String(index + 1).padStart(2, '0');
  return `/images/customers logo/Logo${number}.png`;
});
